export const ACR_TICKS_TO_CQS_MAP = {
  D: 0,
  'CCC/C': 10,
  B: 30,
  BB: 40,
  BBB: 60,
  A: 70,
  'AAA/AA': 90,
};
